import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  POST_SELECTED_CHEF,
  POST_SELECTED_WHEN,
  POST_SELECTED_ZIP
} from "../../store/action";
import { FEATURE_FLAGS } from "../constants/featureFlags";
import { GET } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import SectionFoodList from "../elements/section-food-list";

import { useLocation } from "react-router-dom";

import { configureCrisp } from "../../utils/crispConfig";
import { createLogger } from "../../utils/logger";

const logger = createLogger("LayoutChefFood");
const LayoutChefFood = () => {
  const history = useHistory();
  const [_, setLoad] = useState(true);

  const [foodList, setFoodList] = useState([]);
  const [reviewList, setReviewList] = useState([]);
  const [blogList, setBlogList] = useState([]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Access the query parameter values
  const selectedChefId = searchParams.get("chef");
  const dateParam = searchParams.get("date");

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);
  let user = useSelector((state) => state.user);

  let selectedChef = useSelector((state) => state.selectedChef);

  const dispatch = useDispatch();

  // Update date from URL parameter immediately
  useEffect(() => {
    if (dateParam) {
      WhenDate(dateParam);
      logger.log("Date from URL:", dateParam);
    }
  }, [dateParam]);

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, [dateParam]); // Re-run when dateParam changes

  const whichChef = (value) => dispatch(post_selected_chef(value));

  const whichZip = (value) => dispatch(post_selected_zip(value));

  const initialData = async () => {
    const tday = dayPlusOne();

    // If date is in URL, use it; otherwise fallback to selectedWhen or today
    if (dateParam) {
      WhenDate(dateParam);
    } else if (selectedWhen === null || selectedWhen < tday) {
      WhenDate(tday);
    }


    if (!selectedChefId && !selectedChef) {
      return history.push("/");
    }

    if (!selectedChef) {
      const request_details_chef = {
        type: GET,
        url: service_api,
        route: `user/get-chef-user/${selectedChefId}`,
        token: user?.refresh_token || null
      };

      try {
        const response = await MakeRequestAsync(request_details_chef);
        // setLoad(false);
        const decryptedData = decryptSingleData(response.data.user);
        whichZip(decryptedData.zip);
        whichChef(decryptedData);
        // I have to make sure to look for availability also here
      } catch (err) {
        setLoad(false);
        logger.log("We couldn't fetch data: ", err?.response?.data?.message);
        return history.push("/");
        // return openNotificationWithIcon(
        //   "error",
        //   "An error has occured while login, please try again"
        // );
      }
    }

    const request_details_reviews = {
      type: GET,
      url: service_api,
      route: `order/get-user-reviews/${selectedChefId ?? selectedChef._id}`,
      data: null,
      token: null
    };

    const request_details_blog = {
      type: GET,
      url: service_api,
      route: `blog/get-actif/${selectedChefId ?? selectedChef._id}`,
      data: null,
      token: null
    };

    const request_details_food = {
      type: GET,
      url: service_api,
      route: `food/get-actif-chef/${selectedChefId ?? selectedChef._id}`,
      token: null
    };

    try {
      // Conditionally fetch blog data based on feature flag
      const requests = [
        MakeRequestAsync(request_details_reviews),
        MakeRequestAsync(request_details_food)
      ];

      if (FEATURE_FLAGS.blogEnabled) {
        requests.splice(1, 0, MakeRequestAsync(request_details_blog));
      }

      // Fetch reviews, blogs (if enabled), and food concurrently for better performance
      const responses = await Promise.all(requests);

      const reviewsResponse = responses[0];
      const blogResponse = FEATURE_FLAGS.blogEnabled ? responses[1] : null;
      const foodResponse = FEATURE_FLAGS.blogEnabled
        ? responses[2]
        : responses[1];

      // Decrypt responses concurrently
      const decryptPromises = [
        decryptSingleData(reviewsResponse.data.order),
        decryptSingleData(foodResponse.data.food)
      ];

      if (FEATURE_FLAGS.blogEnabled && blogResponse) {
        decryptPromises.splice(1, 0, decryptSingleData(blogResponse.data.blog));
      }

      const decryptedData = await Promise.all(decryptPromises);

      const reviewsData = decryptedData[0];
      const blogData = FEATURE_FLAGS.blogEnabled ? decryptedData[1] : [];
      const foodData = FEATURE_FLAGS.blogEnabled
        ? decryptedData[2]
        : decryptedData[1];

      setReviewList(reviewsData);
      setBlogList(blogData);
      setFoodList(foodData);
    } catch (err) {
      setLoad(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return history.push("/");
    }
  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        {/* Tu dois ajouter tout les autre compasant du projet ici */}
        <SectionFoodList
          searched=""
          list={foodList}
          reviewList={reviewList}
          blogList={blogList}
          lang={selectedLang}
          whichChef={whichChef}
        />
      </div>
      <div
        style={{
          height: 80
        }}
      ></div>
    </div>
  );
};

export default LayoutChefFood;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});

const post_selected_zip = (data) => ({
  type: POST_SELECTED_ZIP,
  data: data
});

const post_selected_chef = (data) => ({
  type: POST_SELECTED_CHEF,
  data: data
});
